import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Box } from '@material-ui/core';
import { ReactComponent as IconTrash } from '../../assets/svg/icon_trash.svg';
import { ReactComponent as IconTrashLight } from '../../assets/svg/icon_trash_light.svg';
import { ReactComponent as IconSubtract } from '../../assets/svg/iconSubtract.svg';
import { ReactComponent as IconAdd } from '../../assets/svg/icon_add.svg';
import themes from 'styles/themes';

const useLightStyles = makeStyles((theme) => ({
    groupQuantity: {
        padding: '6px',
        border: `1px solid ${themes.palette.secondary['200']}`,
        borderRadius: '29px',
        display: 'flex',
    },
    itemQuantity: {
        color: themes.palette.primary.main,
        fontSize: 14,
        fontWeight: 400,
        lineHeight: '20px',
        padding: '0 12px',
    },
}));
const useDarkStyles = makeStyles((theme) => ({
    groupQuantity: {
        padding: '6px',
        border: `1px solid ${themes.palette.secondary['200']}`,
        borderRadius: '29px',
        display: 'flex',
    },
    itemQuantity: {
        color: themes.palette.primary.main,
        fontSize: 14,
        fontWeight: 400,
        lineHeight: '20px',
        padding: '0 12px',
    },
}));

export interface StandardQuantityBoxProps {
    id: string;
    index: number;
    quantity: number;
    handleChangeQuantity: (index: number, value: number) => void;
    isDelete: boolean;
    disable?: boolean;
    theme?: 'light' | 'dark';
}

export const StandardQuantityBox = (props: StandardQuantityBoxProps) => {
    const { index, quantity, handleChangeQuantity, isDelete, disable, theme } = props;
    const darkStyles = useDarkStyles();
    const lightStyles = useLightStyles();
    const classes = theme === 'dark' ? darkStyles : lightStyles;
    const DeleteIcon = theme === 'dark' ? IconTrashLight : IconTrash;
    return (
        <Box className={classes.groupQuantity}>
            {isDelete ? (
                <DeleteIcon
                    style={{
                        cursor: 'pointer',
                        opacity: disable ? 0.6 : 1,
                        textAlign: 'center',
                        color: themes.palette.primary.main,
                    }}
                    onClick={() => {
                        if (disable) {
                            return;
                        }
                        handleChangeQuantity(index, 0);
                    }}
                />
            ) : (
                <span
                    onClick={() => {
                        if (disable) {
                            return;
                        }
                        handleChangeQuantity(index, -1);
                    }}
                    style={{
                        width: 20,
                        height: 20,
                        borderRadius: '50%',
                        backgroundColor: themes.palette.secondary['500'],
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <IconSubtract style={{ cursor: 'pointer', opacity: disable ? 0.6 : 1, textAlign: 'center' }} />
                </span>
            )}
            <span className={classes.itemQuantity}>{quantity}</span>
            <span
                onClick={() => {
                    if (disable) {
                        return;
                    }
                    handleChangeQuantity(index, 1);
                }}
                style={{
                    width: 20,
                    height: 20,
                    borderRadius: '50%',
                    backgroundColor: themes.palette.secondary['500'],
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <IconAdd style={{ cursor: 'pointer', opacity: disable ? 0.6 : 1 }} />
            </span>
        </Box>
    );
};
